import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Col, Row } from "react-bootstrap";
import "./generate-report-modal.scss";
import ReportsService from "../../../../../../../../../services/reports-service";

const GenerateReportModal = ({ show, onClose, reports }) => {
    const reportsService = new ReportsService();

    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const [formData, setFormData] = useState({
        addresseeTitle: "Mr.",
        firstName: "",
        middleInitial: "",
        lastName: "",
        designation: "",
        companyName: "",
        address: ""
    });

    useEffect(() => {
        // console.log("Reports:", reports);
    }, [reports]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        if (Object.values(formData).some(value => value.trim() === "")) {
            alert("All fields are required.");
            return;
        }
    
        const requestData = {
            institutionId: reports[0].institutionId,
            issuerRequestDate: reports[0].issuerRequestDate,
            reportType: reports[0].reportType,
            addressee: [{
                addresseeTitle: formData.addresseeTitle,
                firstName: formData.firstName,
                middleInitial: formData.middleInitial,
                lastName: formData.lastName
            }],
            address: formData.address,
            companyName: formData.companyName,
            designation: formData.designation
        };
    
        try {
            const response = await reportsService.rrMakerGenerateAuditConfirmation(
                requestData.institutionId,
                requestData.issuerRequestDate,
                requestData.reportType,
                requestData.addressee,
                requestData.address,
                requestData.companyName,
                requestData.designation
            );
    
            // console.log(response);
    
            if (response.statusCode === 200) {
                onClose();  // ✅ Close the original modal
                setTimeout(() => setShowSuccessModal(true), 300); // ✅ Delay slightly to prevent flicker
            }
        } catch (error) {
            alert("Error submitting the report.");
        }
    };

    return (
        <>
        <Modal show={show} onHide={onClose} centered className="generate-report-modal">
            <Modal.Header closeButton>
                <Modal.Title>Generate Report</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row className="mb-3 align-items-center">
                        <Col xs="auto">
                            <Form.Label className="mb-0">Addressee</Form.Label>
                        </Col>
                        <Col xs="auto">
                            <Form.Group>
                                <Form.Control as="select" name="addresseeTitle" size="sm" className="mt-3 form-select" onChange={handleChange}>
                                    <option>Mr.</option>
                                    <option>Ms.</option>
                                    <option>Mrs.</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col xs={5}>
                            <Form.Group className="pt-3">
                                <Form.Control type="text" name="firstName" placeholder="Enter First Name" onChange={handleChange} />
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <Form.Group className="pt-3">
                                <Form.Control type="text" name="middleInitial" placeholder="M" maxLength={1} size="sm" className="middle-initial-input" onChange={handleChange} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3 align-items-center">
                        <Col xs={{ span: 4, offset: 2 }}>
                            <Form.Group>
                                <Form.Control type="text" name="lastName" placeholder="Enter Last Name" onChange={handleChange} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group>
                        <Form.Label>Designation</Form.Label>
                        <Form.Control type="text" name="designation" placeholder="Enter Designation" onChange={handleChange} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Company</Form.Label>
                        <Form.Control type="text" name="companyName" placeholder="Enter Company Name" onChange={handleChange} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Address</Form.Label>
                        <Form.Control type="text" name="address" placeholder="Enter Address" onChange={handleChange} />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>Close</Button>
                <Button variant="primary" onClick={handleSubmit}>Confirm</Button>
            </Modal.Footer>
        </Modal>

        <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title>Success</Modal.Title>
            </Modal.Header>
            <Modal.Body>Report is generating. refresh in a few minutes!</Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => window.location.reload()}>OK</Button>
            </Modal.Footer>
        </Modal>

        </>
    );
};

export default GenerateReportModal;